import { Fragment, useState } from 'react';
import useDeviceTypesStore from 'store/device-types';
import api from 'util/api';
import { createModal, Tooltip } from '@thermon-platforms/thermon-ui-core';
import ParametersModal from './parameters-modal';
import useUsersStore from 'store/users';
import useRolesStore from 'store/roles';

const blocklist = ['Swap', 'Get T2000 mappings', 'Add T2000 Card', 'Remove T2000 Card', 'Replace T2000 Card'];

function Action({device, action}) {
  const [loading, setLoading] = useState(false);

  function handleAction() {
    if (action.parameters) {
      return createModal(<ParametersModal action={action} device={device} />)
      .open()
      .catch(() => {/* no-op */});
    }

    setLoading(true);
    return api(`/devices/${device.id}${action.url}`, { method: action.method })
      .finally(() => {
        // The api is usually pretty quick so lets add a slight delay to make sure the
        // user sees the loading indication
        setTimeout(() => {
          setLoading(false);
        }, 300);
      });
  }
  return (
    <button
      className={`${action.name.toLowerCase().split(' ').join('-')} ${loading ? 'processing' : ''}`}
      data-tooltip-content={action.name}
      data-tooltip-id="actions-tooltip"
      disabled={loading}
      onClick={handleAction}
    >
      {action.name}
    </button>
  )
}

function Actions({device, wrapper=false}) {
  const [, usersStoreActions] = useUsersStore();
  const [rolesStore] = useRolesStore();
  const [deviceTypes] = useDeviceTypesStore();
  const type = deviceTypes.types.find(t => t.id == device.deviceModel);

  if (!usersStoreActions.checkAccess('CanChangeConfiguration', rolesStore.roles)) return null;

  return (<>
    {type?.actions?.map(action => {
      if (blocklist.includes(action.name)) {
        return null;
      }
      return (<Fragment key={`actions-${device.id}-${action.name}`}>
        {wrapper ?
          <li><Action device={device} action={action} /></li> :
          <Action device={device} action={action} />
        }
      </Fragment>)
    })}
    <Tooltip id="actions-tooltip" />
  </>)
}

export { Action };
export default Actions;
